import linea3_preview_1_mb from "./linea3-preview-1-mb.png"
import linea3_preview_1 from "./linea3-preview-1.png"
import linea3_preview_2_mb from "./linea3-preview-2-mb.png"
import modal_background_menstruacion from "./modal-background-menstruacion.png"
import modal_background_menstruacion_2x from "./modal-background-menstruacion@2x.png"
import modal_background_pubertad from "./modal-background-pubertad.png"
import modal_background_pubertad_2x from "./modal-background-pubertad@2x.png"
import modal_background_zona_v from "./modal-background-zona-v.png"
import modal_background_zona_v_2x from "./modal-background-zona-v@2x.png"
import snake_preview_1 from "./snake-preview-1.png"
import snake_preview_2 from "./snake-preview-2.png"
import tetris_preview_2 from "./tetris-preview-2.png"
import tetris_preview_mb_3 from "./tetris-preview-mb-3.png"
import tetris_preview from "./tetris-preview.png"
import tetris_preview_2_arg from "./tetris-preview-2-arg.png"
import tetris_preview_mb_3_arg from "./tetris-preview-mb-3-arg.png"
import snake_preview_1_arg from "./snake-preview-1-arg.png"
import linea3_preview_1_arg from "./linea3-preview-1-arg.png"
import linea3_preview_2_mb_arg from "./linea3-preview-2-mb-arg.png"
import linea3_preview_1_mb_arg from "./linea3-preview-1-mb-arg.png"

export default {
    linea3_preview_1_mb,
    linea3_preview_1,
    linea3_preview_2_mb,
    modal_background_menstruacion,
    modal_background_menstruacion_2x,
    modal_background_pubertad,
    modal_background_pubertad_2x,
    modal_background_zona_v,
    modal_background_zona_v_2x,
    snake_preview_1,
    snake_preview_2,
    tetris_preview_2,
    tetris_preview_mb_3,
    tetris_preview,
    tetris_preview_2_arg,
    tetris_preview_mb_3_arg,
    snake_preview_1_arg,
    linea3_preview_1_arg,
    linea3_preview_2_mb_arg,
    linea3_preview_1_mb_arg,
}